import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=47fd7c9a&scoped=true"
import script from "./Modal.js?vue&type=script&lang=js&external"
export * from "./Modal.js?vue&type=script&lang=js&external"
import style0 from "./Modal.vue?vue&type=style&index=0&id=47fd7c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fd7c9a",
  null
  
)

export default component.exports